import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { PACKAGE_CONFIRMATION } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { PackageConfirmationRequest, PackageConfirmationResponse } from '~/types/api';
import { MutationError } from '~/types/form';
import { PackageConfirmationRequestSchema, PackageConfirmationResponseSchema } from '~/validation/api/packageConfirmationResponse';

export const updatePackageConfirmation = async (obj: PackageConfirmationRequest) => {
  const body = PackageConfirmationRequestSchema.parse(obj);

  try {
    const response = await axios.post(PACKAGE_CONFIRMATION, body);

    const json = response.data;

    return PackageConfirmationResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function useMutatePackageConfirmation() {
  return useMutation<PackageConfirmationResponse, MutationError, PackageConfirmationRequest>({
    mutationFn: (obj: PackageConfirmationRequest) => {
      return updatePackageConfirmation(obj);
    },
  });
}
